import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
const getToken = () => localStorage.getItem("token");

export const createOrder = async (payload) => {

  return axios.post(`${API_BASE_URL}/order`, payload, {
    headers: { token: getToken() },
  });
};

export const createPublicOrder = async (payload) => {

  return axios.post(`${API_BASE_URL}/admin/public-order`, payload, {
    headers: { token: getToken() },
  });
};

export const getBookings = async ({ offset = 1, limit = 10 } = {}) => {
  return axios.get(`${API_BASE_URL}/admin/booking`, {
    params: { offset, limit },
    headers: { token: getToken() },
  });
};

export const getPartnerBookings = async ({ offset = 1, limit = 10 } = {}) => {
  return axios.get(`${API_BASE_URL}/admin/partner-booking`, {
    params: { offset, limit },
    headers: { token: getToken() },
  });
};


export const updateBookingStatus = async (orderId, payload) => {
  const token = localStorage.getItem("token");

  return axios.put(
    `${API_BASE_URL}/admin/booking/${orderId}`,
    payload,
    {
      headers: {
        token,
      },
    }
  );
};

export const quotationFileUpload = async (orderId, file, uploadedBy) => {
  const token = localStorage.getItem("token");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("orderId", orderId);
  formData.append("uploadedBy", uploadedBy);

  return axios.post(
    `${API_BASE_URL}/upload/quotation`,
    formData,
    {
      headers: {
        token,
      },
    }
  );
};

export const contractFileUpload = async (partnerId, file) => {
  const token = localStorage.getItem("token");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("partnerId", partnerId);

  return axios.post(
    `${API_BASE_URL}/upload/partner-contract`,
    formData,
    {
      headers: {
        token,
      },
    }
  );
};


